import type { QueryApi } from "../../api/query";

export function createUseFavouriteShops($api: QueryApi) {
  return function useFavouriteShops(
    params: { page?: number; size?: number } = {},
    options?: { enabled?: boolean },
  ) {
    return $api.useQuery("get", "/favourite-shops", {
      params: { query: { page: params.page ?? 0, size: params.size ?? 10 } },
    }, {
      staleTime: 2 * 60_000,
      ...options,
    });
  };
}
